import { Tile, Wind } from './Tiles';

export type PlayerIndex = 0 | 1 | 2 | 3;

export interface Meld {
    type: 'chi' | 'pon' | 'kan' | 'closed_kan' | 'added_kan';
    tiles: Tile[];
    fromWho?: PlayerIndex;
}

const TYPE_PRIORITY: Record<string, number> = {
    'man': 0, 'pin': 1, 'sou': 2, 'wind': 3, 'dragon': 4
};

const VALUE_PRIORITY: Record<string, number> = {
    'east': 0, 'south': 1, 'west': 2, 'north': 3,
    'white': 0, 'green': 1, 'red': 2
};

export function sortHand(hand: Tile[]): Tile[] {
    return [...hand].sort((a, b) => {
        if (a.type !== b.type) {
            return (TYPE_PRIORITY[a.type] ?? 99) - (TYPE_PRIORITY[b.type] ?? 99);
        }
        if (typeof a.value === 'number' && typeof b.value === 'number') {
            return a.value - b.value;
        }
        // Handle Wind/Dragon value sorting
        const valA = VALUE_PRIORITY[String(a.value)] ?? 0;
        const valB = VALUE_PRIORITY[String(b.value)] ?? 0;
        return valA - valB;
    });
}

export class Player {
    index: PlayerIndex;
    wind: Wind;
    points: number;
    hand: Tile[];
    discards: Tile[];
    melds: Meld[];
    isRiichi: boolean;

    constructor(index: PlayerIndex, wind: Wind, hand: Tile[] = []) {
        this.index = index;
        this.wind = wind;
        this.points = 25000;
        this.hand = sortHand(hand);
        this.discards = [];
        this.melds = [];
        this.isRiichi = false;
    }

    draw(tile: Tile) {
        this.hand.push(tile);
    }

    discard(tileIndex: number): Tile {
        if (tileIndex < 0 || tileIndex >= this.hand.length) {
            throw new Error(`Invalid tile index: ${tileIndex}`);
        }
        const tile = this.hand.splice(tileIndex, 1)[0];
        this.discards.push(tile);
        this.hand = sortHand(this.hand);
        return tile;
    }

    declareRiichi() {
        if (this.isRiichi) return;
        if (this.points >= 1000) {
            this.isRiichi = true;
            this.points -= 1000;
        } else {
            throw new Error("Not enough points to declare Riichi");
        }
    }

    addMeld(meld: Meld) {
        this.melds.push(meld);
    }
}
